// main imports
import React from 'react'
import { createRoot } from 'react-dom/client.js'
import App from './App.jsx'

import * as serviceWorker from './utils/wordpress/serviceWorker'
import { ApolloProvider, client } from './utils/apollo'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { root as renderRoot } from './utils/wordpress/wordpressGetter'
import store from './utils/redux/store/store'

let root = createRoot(renderRoot)

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <HelmetProvider>
                <ApolloProvider client={client}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ApolloProvider>
            </HelmetProvider>
        </Provider>
    </React.StrictMode>
)

// start service worker
serviceWorker.unregister()
